// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"_p-z","slideIn":"aq-z"};